//获取地址栏参数
export const getUrlParams = (key) => {
    const reg = new RegExp("(^|&)" + key + "=([^&]*)(&|$)");
    const r = window.location.search.substr(1).match(reg);
    if (r != null)
        return unescape(r[2]);
    return null;
}